import type { QueryClient } from "@tanstack/react-query";

import { invalidateFavoritesList } from "@/queries/favorites";

interface SkillCollectionScope {
  workspaceId: number;
  collectionId: string | number;
}

const getCollectionIdKey = (collectionId: string | number) => String(collectionId);

export const invalidateSkillCollectionListQueries = (
  queryClient: QueryClient,
  workspaceId: number,
) => {
  queryClient.invalidateQueries({ queryKey: ["skill-collections", workspaceId] });
  queryClient.invalidateQueries({ queryKey: ["folder-entities"] });
  invalidateFavoritesList(queryClient, workspaceId);
};

export const invalidateSkillCollectionDetailQueries = (
  queryClient: QueryClient,
  { workspaceId, collectionId }: SkillCollectionScope,
) => {
  const collectionIdKey = getCollectionIdKey(collectionId);

  queryClient.invalidateQueries({
    queryKey: ["skill-collection", workspaceId, collectionIdKey],
  });
  queryClient.invalidateQueries({
    queryKey: ["skill-collection-files", workspaceId, collectionIdKey],
  });
  queryClient.invalidateQueries({
    queryKey: ["skill-collection-versions", workspaceId, collectionIdKey],
  });
};

export const invalidateSkillCollectionVersionQueries = (
  queryClient: QueryClient,
  { workspaceId, collectionId }: SkillCollectionScope,
) =>
  queryClient.invalidateQueries({
    queryKey: ["skill-collection-versions", workspaceId, getCollectionIdKey(collectionId)],
  });
